import { ViewContext } from '../../enums';

const InputFieldAccessGrants = ({
  // DEPENDENCIES
  client,
  context,
  employee,
  isEditMode,
  isProjectAppointment,
  isRecurring,
  isRecurringChecked,
  isVV,
  isWorkPlaceAppointment,
  periodType
}: // ^
{
  [key: string]: any;
}) => ({
  ACTIVITY_SELECT: [
    isProjectAppointment,
    isWorkPlaceAppointment,
    isVV && !isEditMode
  ],
  //CANDIDATE_EMPLOYMENT: [isVV], // TODO: don't show if is route
  CLIENT: [!isProjectAppointment],
  CLIENT_AVATAR: [!!client],
  DAY_IN_WEEK_SET: [
    !isWorkPlaceAppointment && !isProjectAppointment && !isEditMode
  ],
  DESCRIPTION: [
    !isEditMode,
    isWorkPlaceAppointment,
    isProjectAppointment,
    isVV
  ],
  EMPLOYEE: [
    isProjectAppointment,
    isWorkPlaceAppointment && isEditMode && !!employee
  ],
  EMPLOYEE_AVATAR: [
    isProjectAppointment && !!employee,
    isWorkPlaceAppointment && isEditMode && !!employee
  ],
  EMPLOYEE_TYPE_SELECT: [isVV],
  END_TIME: [!isProjectAppointment],
  EXTRA: [
    !isEditMode,
    isWorkPlaceAppointment,
    isProjectAppointment,
    isVV,
    !isWorkPlaceAppointment && !!client,
    !isProjectAppointment && !!client
  ],
  LOCATION_TYPE: [!isWorkPlaceAppointment && !isProjectAppointment && !!client],
  PERIOD_TYPE: [
    !isWorkPlaceAppointment &&
      !isProjectAppointment &&
      !isEditMode &&
      !!isRecurringChecked
  ],
  PROJECT_ENTITY_ID: [],
  PROJECT_SELECT: [isProjectAppointment],
  RECURRENCE_RULE_EDIT: [
    !isWorkPlaceAppointment && !isProjectAppointment && !isEditMode
  ],
  RECURRENCE_RULE_VIEW: [
    isRecurring &&
      !isWorkPlaceAppointment &&
      !isProjectAppointment &&
      isEditMode
  ],
  START_DATE_FULL_WIDTH: [isProjectAppointment],
  START_DATE_VALIDATION: [isProjectAppointment || isWorkPlaceAppointment],
  START_TIME: [!isProjectAppointment],
  WEEK_DAYS: [periodType === 'WEEK' && !!isRecurringChecked],
  WHAT: [],
  WHAT_IS_EDITABLE: [
    isWorkPlaceAppointment,
    isProjectAppointment,
    isVV,
    !isEditMode
  ],
  WHERE: [!isProjectAppointment],
  WHERE_IS_EDITABLE: [!isProjectAppointment],
  WHICH: [
    isRecurring &&
      (!isWorkPlaceAppointment || isProjectAppointment) &&
      isEditMode
  ],
  WHO: [
    isProjectAppointment,
    !isWorkPlaceAppointment && (!isEditMode || !!client),
    isWorkPlaceAppointment && isEditMode && !!employee
  ],
  WHO_IS_EDITABLE: [
    ((!isEditMode && isVV) || isProjectAppointment) &&
      context === ViewContext.Team
  ],
  WHO_IS_PREVIEW: [isEditMode, context === ViewContext.Own],
  WORKPLACE_ENTITY_ID: [isWorkPlaceAppointment],
  WORKPLACE_SELECT: [isWorkPlaceAppointment]
});

export type FieldKey = keyof ReturnType<typeof InputFieldAccessGrants>;
const fieldGrants = (deps: {
  [key: string]: any;
}): ((key: FieldKey) => boolean) => {
  return (key: FieldKey) =>
    (InputFieldAccessGrants(deps)[key] as boolean[]).includes(true);
};

export { fieldGrants };
